import React from 'react'
import HighlightText from "./HighlightText"
import { FaStar } from "react-icons/fa";
import ReviewSlider from './newhomepage/ReviewSlider';

const ReviewPage = () => {
  return (
    <div className='mt-10 flex items-center justify-center'>
        <div className='flex flex-col w-[95%]  items-center justify-center text-center'>
        <div className='text'>
                <h1 className='font-bold text-[3rem] text-richblack-800 font-roboto'>Clients Say!</h1>
                <h1 className=' text-md text-richblack-600 mt-3'>With years of experience and satisfied customers,<br/>
                we guarantee quality results.</h1>
                <h1 className='font-bold text-[4rem] mt-5'><HighlightText text={4.8}/></h1>
                <div className='text-yellow-100 flex flex-row items-center justify-center'><div className='flex flex-row mt-3 gap-4 '>
                <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                </div>
                </div>
                <h1 className=' text-4xl mt-6 font-roboto'><HighlightText text={"Average customer rating"}/> </h1>
        </div>
        <div className=' h-[24rem]'>
            {/* review slider create */}
            <ReviewSlider/>
        </div>

        </div>
    </div>
  )
}

export default ReviewPage